<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>

    export default {
        name: 'App'
    }
</script>

<style>
  #app {
    font-family: "PingFangSC-Regular";
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue